
// Function to initialize Swiper only on screens < 1280px
function initializeSwiper() {
  const swiperContainers = document.querySelectorAll(".trending-products-container");
  if (window.innerWidth < 1280 && swiperContainers.length > 0) {

    swiperContainers.forEach((container) => {
      // Check if Swiper is already initialized
      if (!container.swiper) {
        const sectionId = container.dataset.sectionId;
        new Swiper(container, {
          slidesPerView: 1.2,
          spaceBetween: 14,  
          // Navigation arrows
          navigation: {
            nextEl: `[data-section-id="${sectionId}"] .swiper-next`,
            prevEl: `[data-section-id="${sectionId}"] .swiper-prev`,
          },
          breakpoints: {
            768: {
              slidesPerView: 1.5,
            },
          },
          grabCursor: true,
        });
      }
    });
  } 
}

document.addEventListener("DOMContentLoaded", () => {
  initializeSwiper();
});

// Re-initialize on resize
window.addEventListener('resize', initializeSwiper);
